export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/Loc_ation.185b74d3.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};